import './lncanada7/style';
import FormStructure from './lncanada7/form_structure';

export default FormStructure;